<!--
  A pull request's state as GitHub draws it: open, draft, merged or closed
  (`prKind`). The glyph a single row leads with, where a stack's member has
  its node on the rail: a different shape, so a single never reads as a
  stack's next step. Open is drawn in the ink's colour (green means
  approved or passing on this page), a draft muted, merged and closed in
  their own. Colour is not the only cue: each state has its own
  drawing, and its name in words for a screen reader and on hover.
-->
<script lang="ts">
  import { PR_KIND_TEXT, type PrKind } from '../logic/prKind';

  let { kind }: { kind: PrKind } = $props();
</script>

<span class="pr-state {kind}" title={PR_KIND_TEXT[kind]}
  ><svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"
    >{#if kind === 'merged'}<circle cx="4" cy="3.5" r="1.75" /><circle cx="4" cy="12.5" r="1.75" /><circle cx="12" cy="8" r="1.75" /><path d="M4 5.25v5.5M4 5.25c0 2 2 2.75 6.25 2.75" />{:else if kind === 'closed'}<circle
        cx="4"
        cy="3.5"
        r="1.75"
      /><circle cx="4" cy="12.5" r="1.75" /><circle cx="12" cy="12.5" r="1.75" /><path d="M4 5.25v5.5M12 7.5v3.25M10.25 2.25l3.5 3.5M13.75 2.25l-3.5 3.5" />{:else if kind === 'draft'}<circle
        cx="4"
        cy="3.5"
        r="1.75"
      /><circle cx="4" cy="12.5" r="1.75" /><circle cx="12" cy="12.5" r="1.75" /><path d="M4 5.25v5.5" /><path d="M12 3v7.75" stroke-dasharray="1.6 2" />{:else}<circle cx="4" cy="3.5" r="1.75" /><circle
        cx="4"
        cy="12.5"
        r="1.75"
      /><circle cx="12" cy="12.5" r="1.75" /><path d="M4 5.25v5.5M12 10.75V6.5a2.5 2.5 0 0 0-2.5-2.5H8M9.75 2.25L8 4l1.75 1.75" />{/if}</svg
  ><span class="sr-only">{PR_KIND_TEXT[kind]}</span></span
>

<style>
  .pr-state {
    display: inline-grid;
    place-items: center;
    width: 16px;
    height: 16px;
    /* Open is the ink's colour: green here already means approved, or passing. */
    color: var(--fg);
  }
  svg {
    fill: none;
    stroke: currentColor;
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke-linejoin: round;
  }
  .pr-state.draft {
    color: var(--muted);
  }
  .pr-state.merged {
    color: var(--merged);
  }
  .pr-state.closed {
    color: var(--bad);
  }
</style>
